export default __webpack_public_path__ + "static/image02-0e536610750a4f467eeec129c1ef25b9.jpg";